import React, { useState } from "react";
import ConfigurationModal from "./ConfigurationModal";
import MyIcon from "../Common/MyIcon";
import ImportIcon from "../../assets/icons/Icon_Library/application icons/general/import.svg2";
import SolutionImportModal from "./SolutionImportModal";
import SolutionPurchaseModal from "./SolutionPurchaseModal";
import ConfigurationIcon from "../../assets/icons/Icon_Library/application icons/monitoring/configuration-01.svg2";
import PurchaseIcon from "../../assets/icons/Icon_Library/application icons/reports/billing.svg2";
import { Modal } from "react-bootstrap";
import {
  SolutionClientType,
  SolutionType,
} from "../store/slices/settingsSlice";

export default function SolutionOptionsModal({
  solution: p,
  clientSolution,
  purchaseAnother = false,
}: {
  solution: SolutionType;
  clientSolution?: SolutionClientType;
  purchaseAnother?: boolean;
}) {
  const [show, setShow] = useState<boolean>(false);
  const isPurchase = !clientSolution || purchaseAnother;
  const isDeployed = clientSolution?.WasDeployed === true;
  const buttonLabel = isPurchase
    ? purchaseAnother
      ? "Purchase another"
      : "Purchase"
    : isDeployed
    ? "Customize"
    : "Deploy";
  const modalTitle = isPurchase
    ? purchaseAnother
      ? "Purchase Another Solution Instance"
      : "Purchase Solution"
    : isDeployed
    ? "Customize Solution"
    : "Deploy Solution";

  return (
    <>
      <button className="btn" onClick={() => setShow(true)}>
        <div className="d-flex align-items-center">
          <MyIcon
            Icon={
              isPurchase
                ? PurchaseIcon
                : isDeployed
                ? ConfigurationIcon
                : ImportIcon
            }
            width={isDeployed ? 20 : 23}
            className="rounded-3"
          />
          <span className="text-navy fw-bold ms-1">{buttonLabel}</span>
        </div>
      </button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton onHide={() => setShow(false)}>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-solution">
            {isPurchase ? (
              <SolutionPurchaseModal solution={p} />
            ) : (
              <SolutionImportModal
                solutionClientUuid={clientSolution.Uuid}
                setShow={setShow}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
